module.exports = __webpack_public_path__ + "static/media/logo_white_op_klein.2a991d24.png";